<template>
  <base-modal overlay-class="lantern_modal">
    <div class="content">
      <h1>
        <span>{{ getTranslations.modal_pre_lantern_game_title_pt1 }}<br></span>
        {{ getTranslations.modal_pre_lantern_game_title_pt2 }}
      </h1>

      <p>{{ getTranslations.modal_pre_lantern_game_subtitle }}</p>

      <base-image src="/static/images/lanterns/lantern_sign.svg" image-class="middle_img" alt="lantern icon" />

      <p>
        {{ getTranslations.modal_pre_lantern_game_description_pt1 }}
        <span>{{ timerForLanternGame }} {{ getTranslations.modal_pre_lantern_game_description_pt2 }}</span>
        {{ getTranslations.modal_pre_lantern_game_description_pt3 }}
      </p>

      <p>{{ getTranslations.modal_pre_lantern_game_description_pt4 }}</p>

      <base-button
        v-if="canPlay"
        container-class="get_points"
        @button:click="$emit('play:lantern')"
      >
        {{ getTranslations.modal_pre_lantern_game_button_proceed }}
      </base-button>

      <div
        v-else
        class="error_text"
        style="margin-bottom: 16px"
      >
        {{ getTranslations.modal_pre_lantern_game_error_already_played }}
      </div>
    </div>
  </base-modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BaseModal from '../BaseModal.vue';
import BaseImage from '../../image/BaseImage.vue';
import BaseButton from '../../button/BaseButton.vue';

export default {
  name: 'PreLanternGameModal',
  emits: ['play:lantern'],
  components: {
    BaseModal,
    BaseImage,
    BaseButton,
  },
  props: {
    canPlay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('common', [
      'timerForLanternGame',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/modal/game/PreLanternGameModal.vue